import { useMemo } from 'react';

import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';

import { educationFacet } from './searchFacets/educationFacet';
import { employmentTypeFacet } from './searchFacets/employmentTypeFacet';
import { jobFamilyFacet } from './searchFacets/jobFamilyFacet';
import { jobKeywordsFacet } from './searchFacets/jobKeywordsFacet';
import { localeFacet } from './searchFacets/localeFacet';
import { locationTypeFacet } from './searchFacets/locationTypeFacet';
import { orgAreasOfFocusFacet } from './searchFacets/orgAreasOfFocusFacet';
import { orgTypeFacet } from './searchFacets/orgTypeFacet';
import { professionalLevelFacet } from './searchFacets/professionalLevelFacet';
import { recencyFacet } from './searchFacets/recencyFacet';
import { salaryListedFacet } from './searchFacets/salaryListedFacet';

/**
 * Only use this function if the code consuming the output does not rely on a stable object.
 *
 * If it does, use the hook instead
 */
export function unstableJobSearchFacets(i18n: I18nFn) {
  return [
    locationTypeFacet(i18n),
    jobKeywordsFacet(i18n),
    orgAreasOfFocusFacet(i18n),
    educationFacet(i18n),
    salaryListedFacet(i18n),
    professionalLevelFacet(i18n),
    employmentTypeFacet(i18n),
    orgTypeFacet(i18n),
    localeFacet(i18n),
    recencyFacet(i18n),
    jobFamilyFacet(i18n), // not shown in sidebar
  ] as const satisfies SearchFacet[];
}

export function useSearchFacetsJob(i18n: I18nFn) {
  const jobSearchFacets = useMemo(() => unstableJobSearchFacets(i18n), [i18n]);

  return { jobSearchFacets };
}
